/**
 * @group Legal
@summary <blockquote>Common legal definitions referenced across policies and terms.</blockquote>
 * @internal
 */
export const LEGAL_DEFINITIONS = {
  personalInformationDefinition:
    'Personal Information means any information relating to an identified or identifiable natural person, including but not limited to identifiers such as a name, identification number, location data, an online identifier, or one or more factors specific to the physical, physiological, genetic, mental, economic, cultural, or social identity of that natural person.',
  processingDefinition:
    'Processing means any operation or set of operations performed on Personal Information or on sets of Personal Information, whether or not by automated means, such as collection, recording, organisation, structuring, storage, adaptation, retrieval, consultation, use, disclosure, dissemination, alignment, combination, restriction, erasure, or destruction.',
  specialCategoriesNote:
    'Health data and biometric data may constitute special categories of personal information and are processed with heightened safeguards.'
} as const;


